import { gql } from "@apollo/client";
import { CREDIT_FRAGMENT } from "./creditFragment";

const DELETE_CREDIT_DOCUMENTS = gql`
  ${CREDIT_FRAGMENT}
  mutation DeleteCreditDocuments($params: DeleteCreditDocumentsParams!) {
    deleteCreditDocuments(params: $params) {
      ...CreditFields
    }
  }
`;

export default DELETE_CREDIT_DOCUMENTS;
